import { typography, radius } from '@/shared/theme/tokens';

export function ViewToggle({ view, onChange, c, isDark }) {
  const opts = [
    { key: 'live',       label: 'Live',       icon: 'bolt' },
    { key: 'historical', label: 'Historical', icon: 'history' },
  ];
  return (
    <div style={{
      display: 'inline-flex', borderRadius: radius.lg,
      border: `1px solid ${c.border}`,
      background: isDark ? 'rgba(255,255,255,0.04)' : c.bgSubtle,
      padding: '3px', gap: '2px',
    }}>
      {opts.map((opt) => {
        const active = view === opt.key;
        return (
          <button key={opt.key} onClick={() => onChange(opt.key)} style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '6px 14px', borderRadius: radius.md,
            border: 'none', cursor: 'pointer',
            fontSize: typography.fontSize.md, fontWeight: active ? 600 : 500,
            fontFamily: typography.fontFamily.body,
            background: active ? (isDark ? 'rgba(255,255,255,0.1)' : '#fff') : 'transparent',
            color: active ? c.textActive : c.textSubtle,
            boxShadow: active ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
            transition: 'all 0.15s',
          }}>
            <span className="material-symbols-outlined" style={{ fontSize: 15, fontVariationSettings: active ? "'FILL' 1" : "'FILL' 0" }}>
              {opt.icon}
            </span>
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
